"use strict";const e=require("../code.org/index.js"),t=require("../../packages/component-library/node_modules/@mui/material/esm/styles/createTheme.js"),r=t(e,{palette:{primary:{main:"#FF69B4",light:"#FF99CC",dark:"#CC5490",contrastText:"#FFFFFF"}}});module.exports=r;
//# sourceMappingURL=index.js.map
